var components
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  var g0 = _vm.info ? _vm.info.submitDate.substring(0, 16) : null
  var g1 = _vm.info ? _vm.info.happenTime.substring(0, 16) : null
  var m0 = _vm.info ? _vm.returnType(_vm.info.memberType) : null
  var m1 = _vm.info ? _vm.returnType(_vm.info.memberType) : null
  var m2 = _vm.info ? _vm.isTrue(_vm.info.outJiuyi) : null
  var m3 =
    _vm.info && _vm.info.outJiuyi == "0" ? _vm.isTrue(_vm.info.isYiwushi) : null
  var m4 =
    _vm.info && _vm.info.isYiwushi == "0" ? _vm.isTrue(_vm.info.isHurted) : null
  var m5 = _vm.info ? _vm.isTrue(_vm.info.workRelated) : null
  if (!_vm._isMounted) {
    _vm.e0 = function ($event, item) {
      var _temp = arguments[arguments.length - 1].currentTarget.dataset,
        _temp2 = _temp.eventParams || _temp["event-params"],
        item = _temp2.item
      var _temp, _temp2
      _vm.previewImage(
        item.fileurlFull,
        _vm.info.multifileList.map(function (item) {
          return item.fileurlFull
        })
      )
    }
  }
  _vm.$mp.data = Object.assign(
    {},
    {
      $root: {
        g0: g0,
        g1: g1,
        m0: m0,
        m1: m1,
        m2: m2,
        m3: m3,
        m4: m4,
        m5: m5,
      },
    }
  )
}
var recyclableRender = false
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns, recyclableRender, components }